import React, { useState } from 'react';

import { useForm } from 'react-hook-form';
import { NavLink } from 'react-router-dom';

import { resetPassword } from '../api';

const STATUS = {
  SUCCESS: 0,
  ERROR: 1,
};

type FormType = {
  email: string;
};

const ResetPassword: React.FC = () => {
  const [resetPasswordStatus, setResetPasswordStatus] = useState<number | null>(null);
  // eslint-disable-next-line @typescript-eslint/unbound-method
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm<FormType>();

  const handleResetPassword = async ({ email }: FormType): Promise<void> => {
    try {
      await resetPassword(email);
      setResetPasswordStatus(STATUS.SUCCESS);
    } catch {
      setResetPasswordStatus(STATUS.ERROR);
    }
  };

  return (
    <div className="flex flex-col">
      <h2 className="mx-auto">
        Enter your email and you will receive a link to reset your password
      </h2>
      <form className="flex flex-col mt-6" onSubmit={handleSubmit(handleResetPassword)}>
        <label htmlFor="email" className="input-label">
          Email
          <input
            className="input sm:text-sm w-full mt-1 transition duration-150 ease-in-out appearance-none"
            type="text"
            maxLength={100}
            {...register('email', {
              required: 'Email is required.',
              pattern: {
                value: /\w+@\w+.\w+/g,
                message: 'Entered value does not match email format.',
              },
            })}
            data-testid="email"
          />
        </label>
        {errors.email && (
          <p className="error-text" data-testid="email-error">
            {errors?.email?.message}
          </p>
        )}
        {resetPasswordStatus === STATUS.ERROR ? (
          <div className="error-text">There was an error resetting your password.</div>
        ) : null}
        {resetPasswordStatus === STATUS.SUCCESS ? (
          <div
            className="text-primary-0.0 text-sm flex justify-center"
            data-testid="email-sent-success"
          >
            You have received an email to reset your password.
          </div>
        ) : null}
        <button className="btn btn-secondary mt-4" type="submit" data-testid="reset-password-btn">
          RESET MY PASSWORD
        </button>
        <NavLink className="flex" to="../login">
          <button className="btn btn-ghost flex-grow mt-2" type="button">
            BACK TO LOGIN
          </button>
        </NavLink>
      </form>
    </div>
  );
};

export default ResetPassword;
